import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Paper, Link } from "@mui/material";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowConsent(false);
    // Enable Google Analytics
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
      });
      // Initialize analytics after consent is granted
      window.gtag("config", "G-DLKZMPN9E3", {
        anonymize_ip: true,
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setShowConsent(false);
    // Ensure analytics remain disabled
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
        ad_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
      });
    }
  };

  if (!showConsent) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
        animation: "slideUp 0.3s ease-out",
        "@keyframes slideUp": {
          from: {
            transform: "translateY(100%)",
          },
          to: {
            transform: "translateY(0)",
          },
        },
      }}
    >
      <Paper
        sx={{
          maxWidth: "md",
          mx: "auto",
          p: 2,
          backgroundColor: "#fff",
          borderRadius: "0 0 8px 8px",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
          Cookie Consent
        </Typography>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          We use cookies to analyze site traffic and optimize your site
          experience. By accepting, you consent to our use of cookies for
          analytics purposes. You can learn more about our{" "}
          <Link href="/privacy-policy" underline="hover">
            privacy policy
          </Link>{" "}
          or decline to continue without analytics.
        </Typography>
        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={handleDecline}
            size="small"
            sx={{ minWidth: 80 }}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            size="small"
            sx={{ minWidth: 80 }}
          >
            Accept
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default CookieConsent;
